import type { SxProps, Theme } from "@mui/material/styles";
import type { SystemStyleObject } from "@mui/system";

const brandLockupSizes = {
  default: {
    logo: {
      width: 124,
      height: 32,
    },
    titleFontSize: {
      xs: "1.9rem",
      md: "2.2rem",
    },
  },
  compact: {
    logo: {
      width: 134,
      height: 22,
    },
    titleFontSize: {
      xs: "1.875rem",
      md: "1.875rem",
    },
  },
} as const;

const getBrandLockupSize = (compact: boolean) => (compact ? brandLockupSizes.compact : brandLockupSizes.default);

export const brandLockupRootSx: SxProps<Theme> = {
  minWidth: 0,
};

export const brandLockupLogoImageSx: SxProps<Theme> = {
  width: "100%",
  height: "100%",
  objectFit: "contain",
  objectPosition: "left center",
};

export const brandLockupTextWrapperSx: SxProps<Theme> = {
  minWidth: 0,
  minHeight: 32,
  display: "flex",
  alignItems: "center",
  borderLeft: "1px solid var(--border-light)",
  pl: 2,
};

export const getBrandLockupLogoSx = (_theme: Theme, compact: boolean, _inverted: boolean): SystemStyleObject<Theme> => {
  const { logo } = getBrandLockupSize(compact);

  return {
    ...logo,
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    filter: "none",
  };
};

export const getBrandLockupTitleSx = (compact: boolean, hideOnMobile = false): SxProps<Theme> => ({
  display: hideOnMobile ? { xs: "none", sm: "block" } : "block",
  fontSize: getBrandLockupSize(compact).titleFontSize,
  lineHeight: "2.8125rem",
  fontFamily: '"TT Hoves Pro", sans-serif',
  fontWeight: 400,
  whiteSpace: "nowrap",
});
